import { render } from "./MiniWizardSticky.vue?vue&type=template&id=a39ee9dc"
import script from "./MiniWizardSticky.vue?vue&type=script&lang=js"
export * from "./MiniWizardSticky.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__